import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants"

const SUPPORTED_FORMATS = ["application/pdf"];
const FILE_SIZE = 160 * 1024;

export const FormikObj = {
    initialValues: {
        id: "",
        categoryDisplay: "",
        categoryCode : "",
        pages: "",
        status: 'new',
        locationName: "",
        locationId: "",
        document: null,
        selectedPractitionerName : "",
        practitionerId: "",
        patientId: "",
        assignPatient: "",
        organization: "",
    },
    validationSchema: Yup.object({
        categoryCode: conditionalValidation(
            Yup.string(), 
            {
                validation,
                mandatory: true,
                label: "Category"
            }),
        pages: conditionalValidation(
            Yup.string().nullable(true).test("less-than-100", "Pages cannot exceed 100", value => value === null || value === undefined || value <= 100).test("is-three-digit", "Page number must not start with zeros.", value => value === null || value === undefined || /^(?!0)\d{1,3}$/.test(String(value))),
            {
                validation,
                label: "Pages"
            }),
        locationId: conditionalValidation(
            Yup.string(),
            {
                validation,
                mandatory: true,
                label: "Source"
            }),
        status : conditionalValidation(
            Yup.string(),
            {
                validation,
                mandatory: true,
                label: "Status"
            }),
        practitionerId: conditionalValidation(
            Yup.string().nullable(true),
            {
                validation
            }),
        patientId : conditionalValidation(
            Yup.string().nullable(true),
            {
                validation
            }),
        document: Yup.mixed().nullable().required()
            // .test("FILE_SIZE", "Uploaded file is too big.", (value) => !value || (value && value.size <= FILE_SIZE))
            // .test("FILE_FORMAT", "Uploaded file has unsupported format.", (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type)))
        // isRootLevel: Yup.boolean(),
    }),
}

export const FormikObjEdit = {
    initialValues: {
        id: "",
        categoryDisplay: "",
        categoryCode : "",
        pages: "",
        status: 'new',
        locationName: "",
        locationId: "",
        document: null,
        selectedPractitionerName : "",
        practitionerId: "",
        patientId: "",
        assignPatient: "",
        orgId: "",
        organizationName: "",
    },
    validationSchema: Yup.object({
        //categoryCode: Yup.string().required("Required Category field"),
        pages: conditionalValidation(
            Yup.string().nullable(true).test("less-than-100", "Pages cannot exceed 100", value => value === null || value === undefined || value <= 100).test("is-three-digit", "Page number must not start with zeros.", value => value === null || value === undefined || /^(?!0)\d{1,3}$/.test(String(value))),
            {
                validation
            }),
        locationId: conditionalValidation(
            Yup.string(), 
            {
                validation,
                mandatory: true,
                label: "Source"
            }),
        status : conditionalValidation(
            Yup.string(), 
            {
                validation,
                mandatory: true,
                label: "Status"
            }),
        practitionerId: conditionalValidation(
            Yup.string(), 
            {
                validation,
            }),
        patientId : conditionalValidation(
            Yup.string(), 
            {
                validation,
            })
    }),
}

export const filterStatusOptions = [
    { value: "new", name: "New" },
    { value: "assigned", name: "Assigned" },
    { value: "acknowledged", name: "Acknowledged" },
    { value: "completed", name: "Completed" },
    { value: "cancelled", name: "Cancelled" },
]

export const categoryOptions = [
    { value: "result_lab", name: "Lab Result" },
    { value: "result_diagnostic_image", name: "DI Result" },
    { value: "result_referral", name: "Referral Response" },
    { value: "result_unknown", name: "Other" }
];


export const handleExt = (event) => {
    let key = event.key;
    let regex = new RegExp("^[0-9]+$");
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };